import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

import { useUser } from '../UserContext';

const options = {
  api_host: import.meta.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  // persistence: 'localStorage', // Mantém a identidade no localStorage
  session_recording: { recordCrossOriginIframes: true },
};

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const { user } = useUser();

  useEffect(() => {
    if (user?.email) {
      const currentId = posthog.get_distinct_id();

      if (currentId !== user.email) {
        posthog.identify(user.email, { email: user.email });
        posthog.alias(user.email);
        posthog.reloadFeatureFlags();
      }
    }
  }, [user?.email]);
  return (
    <PHProvider apiKey={import.meta.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options}>
      {children}
    </PHProvider>
  );
}
